import axios from "axios"

const listIdMap = {
  donut: "dd4b770b511bedd1b0b437e485674b84",
  positive: "6d1e0a7c102ee3b1809cf42e8cd0c710",
}

// Get the human-readable name of the campaign monitor list
export const getNewsletterName = listId =>
  Object.entries(listIdMap).find(([, val]) => val == listId)[0]

/**
 * Gets the details of a subscriber in Campaign Monitor
 * @param {string} email the email address
 * @param {string} listid the id of the list you're subscribing to
 * @returns {Object}
 */
export async function cmGetSubscriberDetails(email, listid) {
  const newsletterName = getNewsletterName(listid)
  try {
    const params = {
      email,
    }

    const res = await axios.request({
      url: `/api/cm/subscribers/${listid}`,
      params,
    })

    return {
      action: `GET_CM_SUBSCRIBER_DETAILS`,
      name: newsletterName,
      listId: listid,
      data: res.data,
    }
  } catch (error) {
    console.error({ error })
    return {
      action: `GET_CM_SUBSCRIBER_DETAILS`,
      name: newsletterName,
      listId: listid,
      error: error.response.data.Message,
      code: error.response.data.Code,
    }
  }
}

/**
 * Subscribes an email to a Campaign Monitor list
 * @param {string} email the email address to subscribe
 * @param {string} listid the id of the list you're subscribing to
 * @param {{key: String, value: String}[]} customFieldData additional custom field data
 * @returns {Object}
 */
export async function cmAddSubscriber(email, listid, customFieldData) {
  const newsletterName = getNewsletterName(listid)
  try {
    const data = {
      email,
      customFieldData,
    }

    const res = await axios.post(`/api/cm/subscribers/${listid}`, data)

    return {
      action: `EMAIL_OPTIN`,
      name: newsletterName,
      listId: listid,
      data: res.data,
    }
  } catch (error) {
    console.error({ error })
    return {
      action: `EMAIL_OPTIN`,
      name: newsletterName,
      listId: listid,
      error: error.response.data.Message,
      code: error.response.data.Code,
    }
  }
}

/**
 * Deletes an email from a Campaign Monitor list
 * @param {string} email the email address to delete
 * @param {string} listid the id of the list you're subscribing to
 * @returns {Object}
 */
export async function cmDeleteSubscriber(email, listid) {
  const newsletterName = getNewsletterName(listid)
  try {
    const params = {
      email,
    }

    const res = await axios.request({
      method: "delete",
      url: `/api/cm/subscribers/${listid}`,
      params,
    })

    return {
      action: `DELETE_CM_SUBSCRIBER`,
      name: newsletterName,
      listId: listid,
      data: res.data,
    }
  } catch (error) {
    console.error({ error })
    return {
      action: `DELETE_CM_SUBSCRIBER`,
      name: newsletterName,
      listId: listid,
      error: error.response.data.Message,
      code: error.response.data.Code,
    }
  }
}

/**
 * Updates a subscriber in a Campaign Monitor list
 * @param {string} email the email address to subscribe
 * @param {string} listid the id of the list you're subscribing to
 * @param {{key: String, value: String}[]} customFieldData additional custom field data
 * @returns {Object}
 */
export async function cmUpdateSubscriber(email, listid, customFieldData) {
  const newsletterName = getNewsletterName(listid)
  try {
    const data = {
      email,
      customFieldData,
    }

    const res = await axios.put(`/api/cm/subscribers/${listid}`, data)

    return {
      action: `UPDATE_EMAIL_SUBSCRIBER`,
      name: newsletterName,
      listId: listid,
      data: res.data,
    }
  } catch (error) {
    console.error({ error })
    return {
      action: `UPDATE_EMAIL_SUBSCRIBER`,
      name: newsletterName,
      listId: listid,
      error: error.response.data.Message,
      code: error.response.data.Code,
    }
  }
}
